import React, { useState } from "react";
import { Link } from "react-router-dom";
import { links } from "../../../config/ptemax/site";

const navLinks = [
  { href: "/ptemax/free-pte-mock-test", label: "Free Mock Test" },
  { href: "/ptemax/platform", label: "Platform" },
  { href: "/ptemax/pricing", label: "Pricing" },
  { href: "/ptemax/institutes", label: "For Institutes" },
];

export default function PteMaxNav() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="position-sticky top-0"
      style={{
        zIndex: 50,
        borderBottom: "1px solid #22383c",
        background: "rgba(10, 20, 23, 0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      <nav className="container d-flex align-items-center justify-content-between" style={{ height: "64px" }}>
        {/* Logo */}
        <Link to="/ptemax" className="text-decoration-none d-flex align-items-center gap-2" onClick={() => setOpen(false)}>
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="14" stroke="#5fd3c6" strokeWidth="2.5" />
            <circle cx="16" cy="16" r="4" fill="#5fd3c6" />
          </svg>
          <span className="fw-bold fs-5" style={{ color: "#ecf3f1", fontFamily: "'Sora', sans-serif" }}>
            PTE<span style={{ color: "#5fd3c6" }}>Max</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="d-none d-md-flex align-items-center gap-4">
          {navLinks.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              className="text-decoration-none small fw-medium"
              style={{ color: "#b2c4c1", transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#5fd3c6")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#b2c4c1")}
            >
              {l.label}
            </Link>
          ))}
        </div>

        {/* Desktop actions */}
        <div className="d-none d-md-flex align-items-center gap-3">
          <a
            href={links.contact}
            className="text-decoration-none small fw-medium"
            style={{ color: "#b2c4c1" }}
          >
           Contact
          </a>
          <a
            href={links.signIn}
            className="text-decoration-none rounded-3 px-3 py-2 small fw-semibold"
            style={{ backgroundColor: "var(--la-secondary-2)", color: "#ecf3f1" }}
          >
             Sign in
            {/* Start free mock */}
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(!open)}
          className="d-md-none btn p-2"
          style={{ color: "#b2c4c1" }}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            {open ? (
              <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            ) : (
              <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            )}
          </svg>
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="d-md-none px-3 py-3" style={{ borderTop: "1px solid #22383c", background: "#0a1417" }}>
          <div className="d-flex flex-column gap-1">
            {navLinks.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                className="text-decoration-none rounded-2 px-3 py-2 small fw-medium"
                style={{ color: "#b2c4c1" }}
              >
                {l.label}
              </Link>
            ))}
            <a href={links.signIn} className="text-decoration-none rounded-2 px-3 py-2 small fw-medium" style={{ color: "#b2c4c1" }}>
              Sign in
            </a>
            <a href={links.freeMock} className="text-decoration-none rounded-3 px-3 py-2 text-center small fw-semibold mt-2" style={{ backgroundColor: "#1fa89b", color: "#ecf3f1" }}>
              Start free mock
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
